const UserTypes = {
  UPDATE_USER_FEATURES_REQUEST: 'user/UPDATE_USER_FEATURES_REQUEST',
  UPDATE_USER_FEATURES_SUCCESS: 'user/UPDATE_USER_FEATURES_SUCCESS',
  UPDATE_USER_FEATURES_FAILURE: 'user/UPDATE_USER_FEATURES_FAILURE',

  UPDATE_USER_HEARING_PROFILE_REQUEST: 'user/UPATE_USER_HEARING_PROFILE_REQUEST',
  UPDATE_USER_HEARING_PROFILE_SUCCESS: 'user/UPDATE_USER_HEARING_PROFILE_SUCCESS',
  UPDATE_USER_HEARING_PROFILE_FAILURE: 'user/UPDATE_USER_HEARING_PROFILE_FAILURE',

  UPDATE_USER_NAME_REQUEST: 'user/UPDATE_USER_NAME_REQUEST',
  UPDATE_USER_NAME_SUCCESS: 'user/UPDATE_USER_NAME_SUCCESS',
  UPDATE_USER_NAME_FAILURE: 'user/UPDATE_USER_NAME_FAILURE',

  SET_UPDATE_USER_NAME_SUCCESS: 'user/SET_UPDATE_USER_NAME_SUCCESS',

  SET_ORGANIZATION: 'user/SET_ORGANIZATION',
};

export default UserTypes;
